import React from 'react';
import { Link } from '@mui/material';

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const LinkedError: React.FC<{ message: string }> = ({ message }) => {
  const parts = message.split(URL_REGEX);
  return (
    <>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <Link key={i} href={part} target="_blank" rel="noopener" color="inherit" sx={{ fontWeight: 600 }}>
            {part}
          </Link>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        )
      )}
    </>
  );
};

export default LinkedError;
